import angular from 'angular';
import ngFileUpload from 'ng-file-upload';
import {PhotoUploaderService} from "./photo-uploader.service";

export default angular.module('slViz.photoUploaderModule', [
    ngFileUpload
])
    .service('PhotoUploaderService', PhotoUploaderService)
    .name;



// WEBPACK FOOTER //
// ./src/js/components/photo-uploader/index.js